stimulusApp.register(
  "share-buttons",
  class extends Stimulus.Controller {
    connect() {
      this._removeClassTimeoutId = null
      this._lastItem = null
    }

    async copy(event) {
      const item = event.currentTarget

      try {
        await navigator.clipboard.writeText(window.location.href)
      } catch (e) {}

      // Add class to indicate copy success
      item.classList.add("share-buttons--i_copied")

      // Reset any existing timer (e.g., repeated clicks)
      if (this._removeClassTimeoutId) {
        clearTimeout(this._removeClassTimeoutId)
      }

      this._lastItem = item

      // Remove the class after a few seconds
      this._removeClassTimeoutId = setTimeout(() => {
        // Ensure the element still exists and is the same
        if (this._lastItem) {
          this._lastItem.classList.remove("share-buttons--i_copied")
        }

        this._removeClassTimeoutId = null
      }, 2000)
    }

    async share() {
      try {
        await navigator.share({ url: window.location.href })
      } catch (e) {}
    }

    disconnect() {
      // Clear timer on disconnect to avoid running on a detached element
      if (this._removeClassTimeoutId) {
        clearTimeout(this._removeClassTimeoutId)
        this._removeClassTimeoutId = null
      }
    }
  },
)
